export const commonSnapShotWrap = `
    width:100%;
    height:100%;
`;
